import { render, staticRenderFns } from "./LmsCheckoutAddToCart.vue?vue&type=template&id=71f856ff&scoped=true"
import script from "./LmsCheckoutAddToCart.vue?vue&type=script&lang=js"
export * from "./LmsCheckoutAddToCart.vue?vue&type=script&lang=js"
import style0 from "./LmsCheckoutAddToCart.vue?vue&type=style&index=0&id=71f856ff&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71f856ff",
  null
  
)

export default component.exports